<template>
  <div
    class="createrSays_wrap"
    :style="{ backgroundImage: `url(${moduleIconUrl})` }"
    v-if="tasksShow > 0"
  >
    <div class="header">
      <div class="header_info">
        <span
          class="header_title"
          :style="{
            textShadow: `0px 2px 8px ${buttonColor}`,
          }"
          >{{ componentConfig.title }}</span
        >
        <span
          class="header_desc"
          :style="{ textShadow: `0px 2px 8px ${buttonColor}` }"
          >{{ componentConfig.subtitle }}</span
        >
      </div>
      <div
        class="header_change"
        @click="openRule()"
        :style="{ background: buttonColor }"
        v-if="componentConfig.rewardExplain"
      >
        <span class="icon"></span>
        <span class="change">规则</span>
      </div>
    </div>

    <div class="content" v-if="loading">
      <div class="empty">
        <div class="skeleton"></div>
      </div>
    </div>
    <div class="content" v-else>
      <div v-for="task in taskList" :key="task.taskId">
        <div class="task_item" v-if="showTask(task)">
          <img
            class="task_icon"
            :src="taskIcon(task.rewardList[0].type)"
            alt=""
          />
          <div class="task_info">
            <div class="task_name" v-if="task.conditionList[0].type == 1">
              当前页面投递{{ task.conditionList[0].count }}个岗位<span
                >({{ task.conditionList[0].currentCount || 0 }}/{{
                  task.conditionList[0].count
                }})</span
              >
            </div>
            <div class="task_name" v-else-if="task.conditionList[0].type == 2">
              <template v-if="platform.includes('51job')"
                >关注公众号且绑定51账号</template
              >
              <template v-else-if="task.conditionList[0].type ==3">关注公众号且绑定应届生账号</template>
            </div>
            <div class="task_name" v-else-if="task.conditionList[0].type ==101">完成登录</div>
            <div class="task_name" v-else-if="task.conditionList[0].type ==6">开启APP通知</div>
            <div class="task_name" v-else>页面右上角关注本会场</div>

            <div class="task_award">
              获得<span class="award">{{
                rewardList[task.rewardList[0].type]
              }}</span
              >次数<span class="num">+{{ task.rewardList[0].count }}</span>
            </div>
          </div>
          <template v-if="unfinished(task)">
            <div
              v-if="task.conditionList[0].type == 101"
              class="task_type task_type0"
              @click="doAndFinish(task)"
            >
              未完成
            </div>
            <div
              v-else-if="task.conditionList[0].type == 1"
              class="task_type task_type0 task_0402"
              @click="doAndFinish(task)"
            >
              去投递
            </div>
            <div
              v-else-if="task.conditionList[0].type == 6"
              class="task_type task_type1"
              @click="openSetting"
            >
              去完成
            </div>
            <div v-else class="task_type task_type1" @click="openWechat(task.conditionList[0].type)">
              去关注
            </div>
          </template>
          <div
            v-else-if="!task.obtain"
            @click="
              receiveAward(
                task,
                task.rewardList[0].type,
                task.rewardList[0].count
              )
            "
            class="task_type task_type1"
          >
            去领取
          </div>
          <template v-else>
            <div
              v-if="gotCheck(task.rewardList[0].type, task.conditionList[0].type)"
              @click="detailLink(task.rewardList[0].detailLink)"
              class="task_type task_type2"
            >
              去查看
            </div>
            <div v-else class="task_type task_type0">已发放</div>
          </template>
        </div>
      </div>
    </div>
    <div class="reward_box" :id="`reward_box${componentConfig.id}`">
      <div>
        <img src="../../assets/img/activity/tasks/left.png" alt="" />
        <img :src="currReward" alt="" />
        <img src="../../assets/img/activity/tasks/right.png" alt="" />
      </div>
      <div class="reward_name">
        恭喜你获得{{ currRewardCount }}次<br />{{ currRewardText }}
      </div>
    </div>
    <van-action-sheet v-model="showRule">
      <div class="rule_wrap">
        <div class="rule_tit">规则</div>
        <!-- 标题标题标题标题标题标 -->

        <img
          @click="showRule = false"
          class="rule_close"
          src="../../assets/img/activity/tasks/close.svg"
          alt=""
        />
        <div class="rule_content">
          <div
            v-html="
              componentConfig.rewardExplain &&
              componentConfig.rewardExplain.replace(/\r?\n/g, '<br>')
            "
          ></div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { ActionSheet } from "vant";
import { mapState } from "vuex";
export default {
  name: "Tasks",
  components: {
    [ActionSheet.name]: ActionSheet,
  },
  props: {
    componentConfig: {
      type: Object,
      default: () => {},
    },
    pageConfig: {
      type: Object,
      default: () => {},
    },
    isLock: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      taskList: [],
      rewardList: {
        1:"免费简历刷新",
        2:"竞争力分析",
        3:"谁对我感兴趣",
        6:"大转盘抽奖"
      },
      taskIcons: {
        1: require("../../assets/img/activity/tasks/resume_refresh.png"),
        2: require("../../assets/img/activity/tasks/compete.png"),
        3: require("../../assets/img/activity/tasks/interest.png"),
        6: require("../../assets/img/activity/tasks/dzp.png"),
      },
      currReward: require("../../assets/img/activity/tasks/interest.png"),
      currRewardText: "",
      loading: false,
      currRewardCount: 0,
      showRule: false,
      isPollingCount: 0,
    };
  },
  watch: {
    applyJobRefreshTasks: {
      handler(newVal) {
        console.log(newVal, "applyJobRefreshTasks");
        // this.rewardInfoQuery();
      },
      // immediate: false,
    },
  },
  computed: {
    ...mapState(["commonStore"]),
    backgroundConfigDTO(){
      return this.componentConfig.backgroundConfigDTO
    },
    buttonColor(){
      return this.backgroundConfigDTO?.buttonColor||this.pageConfig.buttonColor
    },
    moduleIconUrl(){
      if(this.commonStore.isForPC){
        return this.backgroundConfigDTO?.moduleIconPcUrl||this.pageConfig.moduleIconPcUrl
      }else{
        return this.backgroundConfigDTO?.moduleIconUrl||this.pageConfig.moduleIconUrl
      }
    },
    followActShow(){
      // 当前打开H5的环境是App或小程序。
      return this.platform.includes("App") || this.platform.includes("WX");
      // return true;
    },
    tasksShow() {
      let showTaskCount = 0;
      if (this.accountId) {
        this.taskList.forEach((item) => {
          showTaskCount = showTaskCount + (item.show ? 1 : 0);
        });
      } else {
        showTaskCount = 1;
      }
      // 如果只有一个任务，且是关注本会场任务，且在此平台不展示，返回0
      if(this.taskList.length==1&&this.taskList[0].conditionList[0].type == 3){
        if(!this.followActShow){
          showTaskCount = 0;
        }
      }
      console.log(showTaskCount, this.componentConfig.id, "666");
      return showTaskCount;
    },
    accountId() {
      return this.$store.state.commonStore.accountId;
    },
    platform() {
      return this.$store.state.commonStore.platform;
    },
    applyJobRefreshTasks() {
      return this.$store.state.commonStore.applyJobRefreshTasks;
    },
  },
  mounted() {
    console.log(this.componentConfig, "this.componentConfig");
    if (this.accountId) {
      this.rewardInfoQuery();
    } else {
      this.componentConfig.userIncentiveConfigList.forEach((element) => {
        const commandType = element.conditions[0].type;
        const obj = {
          conditionList: element.conditions,
          id: element.id,
          rewardList: element.rewards,
        };

        if (!(commandType == 6 && this.platform.indexOf('App') == -1)) {
          this.taskList.push(obj);
        }
      });
    }
  },
  methods: {
    openSetting() {
      const path = this.platform == '51jobApp' ? 'qiancheng://home/show_message_setting_page' : 'yingjiesheng://home/openMessageAndSystemSettingPage'
      window.location.href = path
    },
    gotCheck(type, taskType){
      // return this.platform == '51jobApp'
      if (taskType == 6 && this.platform == '51jobApp') {
        return true
      }

      return this.platform == '51jobApp'&&type!=6
    },
    doAndFinish(task){
      // 去登录
      if(task.conditionList[0].type == 101){
        this.$base.toLogin();//先登录
      }else if(task.conditionList[0].type == 1){//投递类组件点击去投递
        this.$emit('scrollToFirstDeliveryComponent')
      }
    },
    openWechat(type) {
      // 关注微信
      if(type==2){
        this.$router.push({ path: "/scanCode" });
      }else if(type==3){// 关注本会场
        if(this.$base.checkLoginStatus(true)){
          this.$EventBus.$emit('subscribeEvent');
        }
      }
    },
    showTask(task) {
      //未登录都展示
      if (!this.accountId) {
        // 关注本会场任务要判断当前平台是否展示
        if(task.conditionList[0].type == 3){
          return this.followActShow
        }else{
          return true;
        }
      } else {
        //登录后判断show
        let show
        // 关注本会场任务要判断当前平台是否展示
        if(task.conditionList[0].type == 3){
          show = this.followActShow&&task.show
        }else{
          show = task.show
        }
        return show;
      }
    },
    unfinished(task) {
      let taskItem = task.conditionList[0];
      return !this.accountId||(taskItem.currentCount || 0) < taskItem.count;
      // if (taskItem.type == 1) {
      //   //1:投递任务
      //   return (taskItem.currentCount || 0) < taskItem.count;
      // } else {
      //   //2:公众号任务
      //   return !task.follow;
      // }
    },
    openRule() {
      this.showRule = true;
    },
    detailLink(link) {
      window.location.href = link;
    },
    taskIcon(rewardType) {
      let src = this.taskIcons[rewardType];
      return src;
    },
    async rewardInfoQuery() {
      this.loading = true;
      const params = {
        accountId: this.accountId,
        componentId: this.componentConfig?.id, //组件/模块id
        fromDomain: this.platform.indexOf("yjs") > -1 ? "yjs" : "51job",
      };
      const res = await this.$api.activity.rewardInfoQuery(params);
      if (+res?.code == "0") {
        this.loading = false;
        this.taskList = res.data.taskList.filter(task => {
          const commandType = task.conditionList[0].type;
          if (!(commandType == 6 && this.platform.indexOf('App') == -1)) {
            return true;
          }
        });
        
        let isPolling = res.data.taskList.some(
          (item) => item.conditionList[0].currentCount < item.conditionList[0].count
        );
        if (isPolling) {
          this.rewardInfoQueryPolling();
        }
        console.log(res);
      } else {
        this.loading = false;
      }
    },
    async rewardInfoQueryPolling() {
      const params = {
        accountId: this.accountId,
        componentId: this.componentConfig?.id, //组件/模块id
        fromDomain: this.platform.indexOf("yjs") > -1 ? "yjs" : "51job",
      };
      const res = await this.$api.activity.rewardInfoQuery(params);
      if (+res?.code == "0") {
        // 模拟测试
        // console.log(this.isPollingCount);
        // if(this.isPollingCount>=2){
        //   res.data.taskList[1].conditionList[0].currentCount = 2
        // }
        let new_taskList = res.data.taskList;
        // console.log(new_taskList);
        // 新任务列表对比旧任务列表改变任务状态
        // 转换为一个 Map，以便更快地查找
        const new_taskList_Map = new Map(
          new_taskList.map((item) => [
            item.taskId,
            item.conditionList[0].currentCount,
          ])
        );
        // 使用 forEach 方法来遍历并更新老数组的原始数据
        this.taskList.forEach((oldItem) => {
          // 尝试从 Map 中获取与 oldItem 具有相同 taskId 的 currentCount 值
          const new_currentCount = new_taskList_Map.get(oldItem.taskId);
          // 如果找到了匹配的值，则更新 oldItem 的 currentCount 属性
          if (new_currentCount !== undefined) {
            this.$set(
              oldItem.conditionList[0],
              "currentCount",
              new_currentCount
            );
          }
        });
        let isPolling = this.isPolling(new_taskList); //是否轮询
        // alert(isPolling)
        if(isPolling){
          setTimeout(() => {
            isPolling = false
          }, 300000);
        }
        if (isPolling) {
          setTimeout(() => {
            this.isPollingCount++;
            // console.log(this.isPollingCount);
            this.rewardInfoQueryPolling();
          }, 5000);
        }
        // console.log(res);
      }
    },
    isPolling(task) {
      for (let i = 0; i < task.length; i++) {
        if (this.unfinished(task[i])) {
          return true;
        }
      }
    },
    async receiveAward(task, rewardType, count) {
      // console.log(rewardType,'rewardType');
      // return
      if (this.isLock) return;
      this.$emit("update:isLock", true);

      const params = {
        accountId: this.accountId,
        componentId: this.componentConfig?.id, //组件/模块id
        taskId: task.taskId,
        busBelong: this.pageConfig.busBelong || "51job",
        fromDomain: this.platform.indexOf("yjs") > -1 ? "yjs" : "51job",
      };
      const res = await this.$api.activity.receiveAward(params);
      if (+res?.code == "0") {
        if(rewardType==6){
          this.$store.commit("setValueLocalStorage", {
            bigWheelCountRefresh: true,
          });
        }
        console.log(res);
        this.currReward = this.taskIcons[rewardType];
        this.currRewardText = this.rewardList[rewardType];
        this.currRewardCount = count;
        let reward_box = document.getElementById(
          `reward_box${this.componentConfig.id}`
        );
        reward_box.style.display = "block";
        setTimeout(() => {
          reward_box.style.display = "none";
          this.$emit("update:isLock", false);
          task.obtain = true;
        }, 3000);
      } else {
        this.$toast.fail(res.message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.createrSays_wrap {
  width: 100%;
  box-sizing: border-box;
  border-radius: 12px 12px 0px 0px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% auto;
  padding-bottom: 24px;
  position: relative;
  .adapt_pc_widescreen & {
    width: 1200px;
    margin: 0 auto;
  }
  .header {
    // display: flex;
    // align-items: baseline;
    padding: 13px 16px 10px 16px;
    // font-weight: 600;
    display: flex;
    align-items: baseline;
    justify-content: space-between;

    // .header_title {
    //   font-size: 20px;
    //   color: #ffffff;
    //   line-height: 30px;
    // }
    // .header_desc {
    //   font-size: 14px;
    //   font-weight: 500;
    //   color: #ffffff;
    //   text-shadow: 0px 2px 8px #e16e69;
    //   margin-left: 9px;
    // }
    .header_info {
      .header_title {
        width: 98px;
        font-size: 20px;
        font-weight: 600;
        color: #ffffff;
        line-height: 30px;
        text-shadow: 0px 2px 8px #e16e69;
      }
      .header_desc {
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        text-shadow: 0px 2px 8px #e16e69;
        margin-left: 9px;
      }
    }
    .header_change {
      width: 66px;
      height: 25px;
      // background: #f96440;
      border-radius: 13px;
      color: #ffffff;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      // margin-left: 19px;
      line-height: 25px;
      .icon {
        width: 16px;
        height: 16px;
        background: url("@/assets/img/activity/tasks/rule.png");
        background-size: cover;
      }
      .change {
        margin-left: 2px;
      }
    }
  }
  .content {
    background: #ffffff;
    border-radius: 8px;
    margin: 8px;
    margin-top: 0px;
    overflow: hidden;
    padding-bottom: 20px;
    .empty {
      width: 100%;
      height: 64px;
      border-radius: 8px;
      box-sizing: border-box;
      position: relative;
      border: 1px solid #ffffff;
      cursor: pointer;
      background-image: url("@/assets/img/activity/empty_company@3x.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .skeleton {
      width: 100%;
      height: 64px;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0) 24%,
        rgba(255, 255, 255, 0.9) 25%,
        rgba(255, 255, 255, 0.9) 75%,
        rgba(255, 255, 255, 0) 76%,
        rgba(255, 255, 255, 0) 100%
      );
      background-size: 50% 100%;
      filter: blur(25px);
      animation: gradient 1.5s linear infinite;
    }

    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }

      100% {
        background-position: 100% 50%;
      }
    }
    .task_item {
      display: flex;
      align-items: center;
      padding: 0 12px;
      margin-top: 20px;
      .task_icon {
        width: 45px;
        height: 45px;
        margin-right: 8px;
      }
      .task_info {
        flex: 1;
        .task_name {
          font-size: 14px;
          font-weight: 600;
          color: #222222;
          span {
            font-size: 12px;
            font-weight: normal;
            color: #7c7f87;
            margin-left: 2px;
          }
        }
        .task_award {
          margin-top: 4px;
          font-weight: 400;
          font-size: 12px;
          color: #7c7f87;
          .award {
            color: #ff6c0e;
          }
          .num {
            color: #ff6c0e;
            font-size: 14px;
            font-weight: 600;
          }
        }
      }
      .task_type {
        line-height: 12px;
        font-size: 12px;
        font-weight: 600;
        color: #ffffff;
        padding: 9px 14px;
        border-radius: 90px;
        background: linear-gradient(180deg, #ffbd65 0%, #ff6332 95%);
      }
      .task_type0 {
        background: #ebedf0;
        color: #b1b7c1;
      }
      .task_type2 {
        background: #fff1eb;
        box-sizing: border-box;
        border: 0.5px solid #ffd3bf;
        color: #ff5500;
        padding: 8px 13px;
      }
      .task_0402{
        border-radius: 90px;
        background: #FFF1EB;
        box-sizing: border-box;
        border: 0.5px solid #FFD3BF;
        font-size: 12px;
        font-weight: 600;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FF5500;
      }
    }
  }
  .reward_box {
    border-radius: 10px;
    opacity: 1;
    background: rgba(0, 0, 0, 0.7);
    padding: 16px 20px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    text-align: center;
    display: none;
    z-index: 999;
    img {
      height: 27px;
    }
    .reward_name {
      font-size: 14px;
      font-weight: normal;
      color: #ffffff;
      margin-top: 8px;
    }
  }
  // #reward_box3923{
  //   display: block;
  // }
  .rule_wrap {
    padding-bottom: 16px;
  }
  .rule_tit {
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0px;
    color: #222222;
    margin: 24px 0 16px;
  }
  .rule_close {
    height: 14px;
    width: 14px;
    position: absolute;
    top: 26px;
    right: 16px;
  }
  .rule_content {
    padding: 2px 16px 0;
    overflow-y: scroll;
    max-height: 55vh;
    div {
      font-size: 14px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0px;
      font-variation-settings: "opsz" auto;
      /* 文字/Text-02正文 */
      color: #4c4f54;
    }
  }
}
</style>
